/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
// material
import {
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Paper,
  TableHead,
  Grid,
  Box,
  TextField,
  Backdrop,
  CircularProgress,
  InputAdornment,
  Skeleton,
  Card,
  LinearProgress,
} from '@mui/material';
// components
import { collection, doc, endBefore, getCountFromServer, getDoc, getDocs, limit, limitToLast, orderBy, query, startAfter } from 'firebase/firestore';
import { format } from 'date-fns';
import fr from 'date-fns/locale/fr';
import Page from '../../../components/Page';
import Scrollbar from '../../../components/Scrollbar';
import Iconify from '../../../components/Iconify';

// mock

import { db } from '../../../firebase.config';
import CheckCard from '../../../components/CheckCard';
import { UserAuth } from '../../../context/AuthContext';
import { Variables } from '../../../context/VariableContext';
import Swipeable from './swiper';
import useResponsive from '../../../hooks/useResponsive';
import CustomButton from '../../../components/CustomButton';
import CustomTag from '../../../components/customTag';
import { getTimeDifferenceInDays } from '../../../utils/functions';
import withAuthorization from '../../../withAuthorization';


function ContactsCrm() {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  const { eventID } = useParams();
  const location = useLocation();
  const { user } = UserAuth();

  // for change value of globla quota
  const [open, setOpen] = React.useState(false);

  const [refreh, setRefresh] = React.useState(false);

  const [filters, setFilters] = useState({
    filterEvent: [],
    filterInterest: [],
    filterNbEvent: { min: '', max: '' },
    filterBillet: { min: '', max: '' },
    totalDepense: { min: '', max: '' },
    lastDateOrder: { before: null, after: null },
    filterNewsletter: null,
    filterNotif: null,
    filterAbonne: null,
    filterHist: null,
    start: null,
    end: null,
  });

  // take operateurs from firebase
  const [contacts, setContact] = React.useState([]);
  const [curent, setCurent] = React.useState();
  const [tmp, setTmp] = React.useState();
  // const [type, setType] = React.useState();
  const [search, setSearch] = React.useState('');
  const [orgID, setOrgID] = React.useState(null);
  const { openDrawer, setOpenDrawer, generalReload } = Variables();
  const { type, setType } = Variables();
  // paginnation variable
  const PAGE_SIZE = 10; // Nombre de contacts par page
  // const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);

  const [queryContains, setQueryContains] = React.useState([]);

  /*
    const handleChangePage = (event, newPage) => {
      if (page < newPage) {
        next();
      } else {
        console.log('back');
        back();
      }
      console.log(newPage);
      setPage(newPage);
    }; */

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };



  /**
   * new pagination system
   */

  async function fetchContactsPage({ orgID, filters, pageSize = 25, cursor = null }) {
    const res = await fetch('https://us-central1-event-86cbf.cloudfunctions.net/contactSearchv2', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orgID, filters, pageSize, cursor }),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json(); // { items, nextCursor, prevCursor, totalPivot, ... }
  }

  const [page, setPage] = React.useState({ items: [], nextCursor: null, prevCursor: null, totalPivot: 0, });
  const [pageIndex, setPageIndex] = React.useState(0);

  const loadFirst = async () => {
    const data = await fetchContactsPage({ orgID, filters, pageSize: PAGE_SIZE });
    setPage(data);
  };

  const loadNext = async () => {
    try {
      setLoading(true)

      if (!page.nextCursor) return;
      const f = filtersFromSearch(location.search);
      const data = await fetchContactsPage({ orgID, filters: f, pageSize: PAGE_SIZE, cursor: page.nextCursor });

      setPage(data);
      setPageIndex((i) => i + 1);
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }

  };

  const loadPrev = async () => {
    try {
      setLoading(true)
      if (!page.prevCursor) return;
      const f = filtersFromSearch(location.search);
      const data = await fetchContactsPage({ orgID, filters: f, pageSize: PAGE_SIZE, cursor: page.prevCursor });

      setPage(data);
      setPageIndex((i) => Math.max(0, i - 1));
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }

  };

  // brancher TablePagination
  const handleChangePage = (_evt, newIndex) => {
    if (newIndex > pageIndex) loadNext();
    else loadPrev();
  };

  React.useEffect(() => {
    (async () => {
      if (!orgID) return;
      try {
        setLoading(true)
        // console.log('new fecth---------------------------------------------------')
        const f = filtersFromSearch(location.search);

        setFilters(f); // pour garder l’UI en phase
        const data = await fetchContactsPage({ orgID, filters: f, pageSize: PAGE_SIZE, cursor: null });

        setCount(data.count);
        setPage(data);
        setPageIndex(0);
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }


    })();
  }, [orgID, location]);


  /**
   *  end new pagination system
   */


  const next = async () => {
    const lastVisible = contacts[contacts.length - 1];
    const querySnapshot1 = await getDocs(
      query(
        collection(db, `organisations/${orgID}/crm/${orgID}/contacts`),
        ...queryContains,
        orderBy('createDate', 'desc'),
        startAfter(lastVisible),
        limit(PAGE_SIZE)
      )
    );
    setContact([]);
    querySnapshot1.forEach(async (d) => {
      setContact((billets) => [...billets, d]);
    });
  };

  const back = async () => {
    const lastVisible = contacts[0];
    const querySnapshot1 = await getDocs(
      query(
        collection(db, `organisations/${orgID}/crm/${orgID}/contacts`),
        ...queryContains,
        orderBy('createDate', 'desc'),
        endBefore(lastVisible),
        limitToLast(PAGE_SIZE)
      )
    );
    setContact([]);
    querySnapshot1.forEach(async (d) => {
      setContact((billets) => [...billets, d]);
    });
  };

  const parseBool = (s) => s === 'true' ? true : s === 'false' ? false : null;
  const parseRange = (sp, key) => ({
    min: sp.get(`${key}_min`) ?? '',
    max: sp.get(`${key}_max`) ?? '',
  });


  const filtersFromSearch = (search) => {
    const sp = new URLSearchParams(search);
    // console.log(sp)
    const csv = (v) => (v ? v.split(',').filter(Boolean) : []);

    const hist = sp.get('hist');

    return {
      filterEvent: csv(sp.get('fe')),
      filterInterest: csv(sp.get('fi')),
      filterNbEvent: parseRange(sp, 'nbe'),
      filterBillet: parseRange(sp, 'nbt'),
      totalDepense: parseRange(sp, 'dep'),
      lastDateOrder: {
        after: sp.get('ldo_after') || null,
        before: sp.get('ldo_before') || null,
      },
      filterNewsletter: parseBool(sp.get('nl')),
      filterNotif: parseBool(sp.get('pn')),
      filterAbonne: parseBool(sp.get('pf')),
      filterHist: hist || null,
      start: hist === 'custom' ? (sp.get('start') || null) : null,
      end: hist === 'custom' ? (sp.get('end') || null) : null,
    };
  };
  // puis, à chaque changement d'URL (et quand orgID est connu), recharge la première page
  const normalizeFilters = (f) => ({
    ...f,
    filterNbEvent: {
      min: f?.filterNbEvent?.min === '' ? null : Number(f.filterNbEvent.min),
      max: f?.filterNbEvent?.max === '' ? null : Number(f.filterNbEvent.max),
    },
    filterBillet: {
      min: f?.filterBillet?.min === '' ? null : Number(f.filterBillet.max) && Number(f.filterBillet.min),
      max: f?.filterBillet?.max === '' ? null : Number(f.filterBillet.max),
    },
    totalDepense: {
      min: f?.totalDepense?.min === '' ? null : Number(f.totalDepense.min),
      max: f?.totalDepense?.max === '' ? null : Number(f.totalDepense.max),
    },
    lastDateOrder: {
      after: f?.lastDateOrder?.after || null,
      before: f?.lastDateOrder?.before || null,
    },
  });

  const inRange = (v, r) => {
    if (!r) return true;

    const { min, max } = r;

    const hasMin = min !== '' && min != null;
    const hasMax = max !== '' && max != null;

    // Si aucune borne → valide
    if (!hasMin && !hasMax) return true;

    // Si valeur absente
    if (v == null || v === undefined) {
      // Cas spécial : seulement max défini → OK
      if (!hasMin && hasMax) return true;
      // Sinon (min défini ou les deux) → invalide
      return false;
    }

    // Convertir proprement
    const numV = Number(v);
    const numMin = hasMin ? Number(min) : null;
    const numMax = hasMax ? Number(max) : null;

    // Comparaisons
    if (hasMin && numV < numMin) return false;
    if (hasMax && numV > numMax) return false;

    return true;
  };




  const inDateRange = (ts, r) => {
    if (!r) return true;
    if (!ts) return false;
    const d = ts.toDate().getTime();
    if (r.after) { const a = new Date(r.after).getTime(); if (d < a) return false; }
    if (r.before) { const b = new Date(r.before).getTime(); if (d > b) return false; }
    return true;
  };

  const matchBool = (v, f) => (f == null ? true : v === f);

  const overlap = (a, b) => {
    if (!a || !b || !Array.isArray(a) || !Array.isArray(b) || b.length === 0) return true;
    return b.some(x => a.includes(x));
  };

  /* React.useEffect(() => {
    (async () => {
      if (!orgID) return;
      console.log('---------------------------------------------------')
      const f = filtersFromSearch(location.search);
      console.log(location.search)
      const f1 = normalizeFilters(f);
      console.log(f)
      console.log('**************************************')
      console.log(f1)

      console.log('---------------------------------------------------')
      // setFilters(f); // pour garder l’UI en phase
      // const data = await fetchContactsPage({ orgID, filters: f, pageSize: PAGE_SIZE, cursor: null });
      // setPage(data);
      // setPageIndex(0);
    })();
  }, [location.search]); */

  React.useEffect(() => {
    (async () => {
      try {
        console.log('+++++++++++++++++++++++++++++++++++++++++++++++++')
        const docs = page.items;
        const f = normalizeFilters(filters);
        const postFilter = (c) => {
          // if (!overlap(c.events, f.filterEvent)) return false;
          // if (!overlap(c.genres, f.filterInterest)) return false;

          if (!inRange(c.events?.length, f.filterNbEvent)) return false
          if (!inRange(c.tickets, f.filterBillet)) return false;
          if (!inRange(c.depenses, f.totalDepense)) return false;

          // if (!inDateRange(c.lastDateOrder, f.lastDateOrder)) return false;

          // if (!matchBool(c.newslettres, f.filterNewsletter == null ? null : f.filterNewsletter)) return false;
          // if (!matchBool(c.push, f.filterNotif == null ? null : f.filterNotif)) return false;
          // if (!matchBool(c.abonne, f.filterAbonne == null ? null : f.filterAbonne)) return false;

          return true;
        };
        let number = 0
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < docs.length; index++) {
          const element = docs[index];

          // console.log(element.id)
          if (postFilter(element)) {
            console.log(element.id)
            console.log(true)
            number += 1
            console.log('----')
          } else {
            console.log(element.id)
            console.log(false)
          }

        }
        console.log(number)
        console.log('end+++++++++++++++++++++++++++++++++++++++++++++++++end')
      } catch (error) {
        console.log(error)
      }

    })();
  }, [filters, page, orgID]);


  React.useEffect(() => {
    (async () => {
      setContact([]);
      try {
        setLoading(true);
        setLoadingPag(true);
        const docRef0 = doc(db, 'organisateurs', `${user.uid}`);
        const docSnap = await getDoc(docRef0);
        setOrgID(docSnap.data().idOrg)
      } catch (error) {
        console.log('error');
      } finally {
        setLoading(false);
        setLoadingPag(false);
      }
    })();
  }, [user, refreh]);


  // loading
  const [loading, setLoading] = React.useState(false);
  const [loadingPag, setLoadingPag] = React.useState(false);

  const handleModif = async (index) => {
    try {
      console.log(page.items[index].uid)
      const docRef0 = doc(db, 'users', `${page.items[index].uid}`);
      const docSnap = await getDoc(docRef0);
      if (docSnap.exists()) {
        setCurent(docSnap?.data());
      } else {
        console.log('client n existe pas')
        console.log(page.items[index])
        setCurent(page.items[index]);
        // setIDContact(contacts[index].id)
      }

    } catch (error) {
      console.log(index)
      console.log('client n existe pas 1')
      console.log(error)
      console.log(index)
      setCurent(page.items[index]);
      setTmp(index)
      setType(1);
      // setIDContact(contacts[index].id)
    }
    console.log(index)
    setTmp(index)
    setType(1);

    setOpenDrawer(!openDrawer);
  };

  const handleFilter = () => {
    setType(2);
    setOpenDrawer(!openDrawer);
  };
  const handleImportation = () => {
    setType(3);
    setOpenDrawer(!openDrawer);
  };

  const handleSearch = async (tmp) => {
    setSearch(tmp);
    if (search.length > 3) {
      // loading
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleTimestamp = (e) => {
    console.log(e)
    const date = e.toDate();
    console.log(date)
    const tmp = date.toJSON().split('.');
    return tmp[0];
  };


  const tsToDate = (ts) =>
    ts?.toDate ? ts.toDate()
      : ts?._seconds ? new Date(ts._seconds * 1000)
        : ts ? new Date(ts) // si string ISO
          : null;



  return (
    <Page title="Contacts">
      <Backdrop sx={{ color: '#ffff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container sx={{ marginTop: { xs: 0 } }}>
        <CheckCard />
        <Stack direction="row" justifyContent="space-between" mb={2}>
          <Typography variant="h3" gutterBottom>
            Contacts
          </Typography>
        </Stack>
        <Grid container paddingBottom={3}>
          <Grid item xs={5}>
            <Stack direction='row' spacing={2}>
              <Stack spacing={1} direction='row' onClick={handleImportation} sx={{ bgcolor: '#f2f2f2', borderRadius: '10px', cursor: 'pointer' }} padding={1} >
                <Iconify icon="material-symbols-light:add" sx={{ width: 20, height: 20 }} />
                <Typography variant='body2'><strong>Importer des contacts</strong></Typography>
              </Stack>
              <Stack spacing={1} direction='row' onClick={handleImportation} sx={{ bgcolor: '#f2f2f2', borderRadius: '10px', cursor: 'pointer' }} padding={1} >
                <Iconify icon="material-symbols-light:download" sx={{ width: 20, height: 20 }} />
                <Typography variant='body2'><strong>Exporter en CSV</strong></Typography>
              </Stack>
            </Stack>
          </Grid>

        </Grid>
        <Grid container spacing={2} paddingBottom={2} sx={{ display: 'flex', alignItems: 'center' }}>
          <Grid item xs={12} sm={4} md={6}>
            {loading ? (
              <Skeleton width="20%">
                <Typography>.</Typography>
              </Skeleton>
            ) : (
              <Typography variant="h6">{count} contacts</Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={8} md={6}>

            <Stack direction='row' spacing={2}>
              <TextField value={search} onChange={(e) => handleSearch(e.target.value)} InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify icon="iconoir:search" />
                  </InputAdornment>
                ),
              }} placeholder="Rechercher" fullWidth />
              <CustomButton type='primaire' startIcon={<Iconify icon="circum:filter" />} buttonText='Filtre' onClick={handleFilter} />
            </Stack>
          </Grid>
        </Grid>
        <Box>
          <Scrollbar>

            <TableContainer component={Paper}>
              {loading && (
                <LinearProgress />
              )}
              <Table sx={{ minWidth: 500 }} aria-label="caption table">
                <TableHead sx={{ bgcolor: '#f2f2f2' }}>
                  <TableRow>
                    <TableCell sx={{
                      position: 'sticky',
                      left: 0,
                      zIndex: 100,
                      whiteSpace: 'nowrap',
                      bgcolor: '#f2f2f2'
                    }}>Nom</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Age</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Dernier achat</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Total dépensé</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Nombre total d'event</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Abonné</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Abonné Notif push</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Abonné Newsletters</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Pays</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Ville</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Téléphone</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap', }}>Date d'ajout</TableCell>
                  </TableRow>
                </TableHead>

                {page.items?.length === 0 && !loading ? (
                  <caption>
                    <Stack spacing={1} sx={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                      <Iconify icon="icomoon-free:drawer2" sx={{ width: 30, height: 30 }} />
                      <Typography variant="caption">Aucune donnée</Typography>
                    </Stack>
                  </caption>
                ) : (
                  <TableBody>
                    {page.items.map((contact, index) => (
                      <TableRow key={index} hover>
                        <TableCell
                          sx={{
                            position: 'sticky',
                            left: 0,
                            zIndex: 100,
                            bgcolor: 'white',
                            cursor: 'default'
                          }}
                          id={contact.nom}
                          onClick={(e) => handleModif(index)}
                          key={contact.nom}
                          component="th"
                          scope="row"
                        >
                          <Stack>
                            <Stack direction="row">
                              {contact.nom} {contact.prenom}
                            </Stack>
                            {contact.id}
                            <Typography variant='caption'>
                              derniere mise le
                              {contact.updateDate ? format(tsToDate(contact?.updateDate), ' eee dd MMM yyyy', {
                                locale: fr,
                              }).toString() : contact.updateDate ? format(tsToDate(contact?.createDate), ' eee dd MMM yyyy', {
                                locale: fr,
                              }).toString() : null}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', }} id={contact.nom} onClick={() => handleModif(index)}>
                          {contact.age ? <CustomTag text={`${contact.age}`} /> : '-'}
                        </TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap', }} id={contact.nom} onClick={() => handleModif(index)}>
                          <Typography variant='caption'>
                            {contact?.lastOrderDate ? format(new Date(handleTimestamp(contact?.lastOrderDate)), 'eee dd MMM yyyy', {
                              locale: fr,
                            }).toString() : '-'}
                          </Typography>
                        </TableCell>

                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          {contact.depenses ? contact.depenses : '-'}
                        </TableCell>
                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          {contact.events ? contact.events.length : '-'}
                        </TableCell>

                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          <CustomTag text={`${contact.newslettres ? 'Oui' : 'Non'}`} type={contact.abonne ? 'success' : 'error'} />
                        </TableCell>
                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          <CustomTag text={`${contact.push ? 'Oui' : 'Non'}`} type={contact.push ? 'success' : 'error'} />
                        </TableCell>
                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          <CustomTag text={`${contact.newslettres ? 'Oui' : 'Non'}`} type={contact.newslettres ? 'success' : 'error'} />
                        </TableCell>

                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          {contact.pays ? contact.pays : '-'}
                        </TableCell>
                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          {contact.ville ? contact.ville : '-'}
                        </TableCell>
                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          {contact.phone ? contact.phone : '-'}
                        </TableCell>
                        <TableCell id={contact.nom} onClick={() => handleModif(index)}>
                          <Typography variant='caption'>
                            {
                              // getTimeDifferenceInDays(contact?.createDate)
                            }
                          </Typography>

                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            {loading ? (
              <LinearProgress />
            ) :
              <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={count}
                rowsPerPage={PAGE_SIZE}
                page={pageIndex}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            }

          </Scrollbar>
        </Box>
        <Swipeable type={type} user={curent} contact={page.items[tmp]} organisation={orgID} />
      </Container>
    </Page>
  );
}
export default withAuthorization(ContactsCrm, "manage_contacts")